import { DateLocalizer, Navigate, ViewProps } from 'react-big-calendar';
import Calendar from 'react-calendar';
import { Grid } from '@mui/material';
import 'react-calendar/dist/Calendar.css';
import '../../styles/calendar-year-view.scss';
import dayjs from 'dayjs';
export default function YearView({
  date,
  localizer,
  onView,
  onNavigate,
  events,
}: ViewProps & { date: Date }) {
  const currRange = YearView.range(date, { localizer });

  return (
    <Grid container>
      {currRange.map((month: Date, index: number) => {
        return (
          <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
            <Calendar
              activeStartDate={month}
              tileClassName={({ date, view }: { date: Date; view: string }) => {
                if (
                  view === 'month' &&
                  events?.find((event) =>
                    dayjs(event.start).isSame(dayjs(date), 'day')
                  )
                )
                  return 'event-day';
                return null;
              }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

YearView.range = (date: Date, { localizer }: { localizer: DateLocalizer }) => {
  const start = localizer.startOf(date, 'month');
  //const end = dayjs(start).add(12, 'month').toDate();

  const range = [];
  let current = start;

  for (let index = 0; index < 12; index++) {
    range.push(current);
    current = localizer.add(current, 1, 'month');
  }

  return range;
};

YearView.navigate = (
  date: Date,
  action: any,
  { localizer }: { localizer: DateLocalizer }
) => {
  if (action instanceof Date) return action;

  switch (action) {
    case Navigate.NEXT:
      return localizer.add(date, 1, 'year');
    case Navigate.PREVIOUS:
      return localizer.add(date, -1, 'year');
    default:
      return date;
  }
};

YearView.title = (date: Date, { localizer }: { localizer: DateLocalizer }) => {
  return localizer.format(date, 'YYYY');
};
